import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { useContext, useMemo, useState } from 'react';
import { useLocalizeMessage, Table, Spinner, Select } from 'libs.nucleus';
import { AuthContext, useApiClient, ApiClientService } from 'libs.react_internal';
import { useDataTemplatesDashboardColumns } from './data_templates_dashboard_columns.hook';
export const DataTemplatesDashboardContent = () => {
    const translate = useLocalizeMessage();
    const { entityId, user } = useContext(AuthContext);
    const webClient = useApiClient(ApiClientService.WEB);
    const [isArchived, setIsArchived] = useState({ label: translate('No'), value: 'false' });
    const [isGlobal, setIsGlobal] = useState({ label: translate('-'), value: '' });
    const retrieveTransferTemplates = async () => {
        const { data } = await webClient.post(`/api/data_transfer/templates/list`);
        return data;
    };
    const { data: transferTemplates = [], isLoading } = useQuery({
        queryKey: ['entities', entityId, 'transfer_templates'],
        queryFn: retrieveTransferTemplates,
        enabled: !!user && !!entityId,
    });
    const { transferTemplateColumns } = useDataTemplatesDashboardColumns();
    const filteredTransferTemplates = useMemo(() => transferTemplates
        .filter((template) => isArchived.value === 'true' ? template.status === 'ARCHIVED' : template.status !== 'ARCHIVED')
        .filter((template) => (isGlobal.value === 'true' ? template.isGlobal : !template.isGlobal)), [transferTemplates, isArchived, isGlobal]);
    if (isLoading) {
        return _jsx(Spinner, { wrapper: 'full' });
    }
    if (transferTemplates.length === 0) {
        return (_jsx("div", { className: 'flex flex-col items-center justify-center border border-border-primary rounded-lg p-24', children: _jsx("p", { className: 'text-text-secondary', children: translate('Create data transfer template usable across studies.') }) }));
    }
    const renderCustomHeaderContent = () => {
        return (_jsxs("div", { className: 'flex gap-4', children: [_jsx(Select, { label: translate('Is archived'), options: [
                        { label: translate('Yes'), value: 'true' },
                        { label: translate('No'), value: 'false' },
                    ], value: isArchived, onChange: (value) => setIsArchived(value), width: 'sm' }), _jsx(Select, { label: translate('Is global'), options: [
                        { label: translate('Yes'), value: 'true' },
                        { label: translate('No'), value: 'false' },
                    ], value: isGlobal, onChange: (value) => setIsGlobal(value), width: 'sm' })] }));
    };
    return (_jsx("div", { "data-testid": 'data-templates-table', children: _jsx(Table, { columns: transferTemplateColumns, data: filteredTransferTemplates, hasPagination: true, initialPageSize: 10, isLoading: isLoading, labelNoResults: translate('No transfer templates'), paginationNavigationScreenReaderLabel: translate('Transfer templates table navigation'), useInternalSearch: true, customHeaderContent: renderCustomHeaderContent() }) }));
};
